
export default function Services() {
  const services = [
    {
      icon: 'ri-graduation-cap-line',
      title: '記憶のオンラインスクール「KIOQ」',
      description: '独自の記憶メソッド(きおクマ式記憶術)を体系的に学べるオンラインスクール「KIOQ」。AIチューターが一人ひとりの学習をサポートし、AIゲームで楽しく継続できます。発達障害・学習障害のあるお子さまの「覚える」という技能を助け、自律的な学習を支援した実績も多数。イメージが苦手な方、読み書きに障害がある方、ADHD・ASDなどの発達特性をお持ちのお子さんも対象で、小さな成功体験を積み重ねながら確実に記憶力を向上させることができます。',
      features: ['独自の記憶メソッド', 'AIチューター&ゲーム', '発達特性対応', '自己肯定感の育成'],
      image: 'https://static.readdy.ai/image/dc94b4331bde31366815bfe78425789e/99bbfcbcf7deee4cf9467000479faf03.jpeg'
    },
    {
      icon: 'ri-building-line',
      title: '法人向け記憶研修',
      description: '企業の人材育成を革新する記憶力向上研修プログラム。確立された再現性の高いメソッドにより、業務に必要な知識の定着、資格取得支援、新人教育における情報習得を強力にサポート。短期間で効率的に覚えられる実践的なスキルを身につけることができます。',
      features: ['実績あるメソッド', '業務知識の定着', '資格取得支援', '効率的な情報習得'],
      image: 'https://static.readdy.ai/image/dc94b4331bde31366815bfe78425789e/0cf4117a71bd2bfcaa33ef2c099470c7.jpeg'
    },
    {
      icon: 'ri-book-open-line',
      title: '教育コンテンツ制作',
      description: '学習塾や学校向けに、独自の記憶メソッドを活用した教育コンテンツを制作。多様な学習スタイルに対応し、特別支援教育にも活用できる包括的なカリキュラム設計から、AIを活用したデジタルコンテンツまで、すべての子どもたちが「覚えられた」という成功体験を得られる教材を提供します。',
      features: ['独自メソッド活用', '特別支援教育対応', 'AI活用コンテンツ', '成功体験重視'],
      image: 'https://static.readdy.ai/image/dc94b4331bde31366815bfe78425789e/f7b7dc14a1295a404351610304283fbd.jpeg'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-sm text-secondary mb-4 tracking-widest">SERVICE</p>
          <h3 className="text-4xl font-bold text-primary mb-4">事業内容</h3>
          <p className="text-xl text-secondary max-w-3xl mx-auto">
            独自メソッドとAIで、すべての人に学びの成功体験を
          </p>
        </div>

        <div className="grid md:grid-cols-1 gap-12">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white overflow-hidden hover:shadow-xl transition-all duration-300"
            >
              <div className="grid md:grid-cols-2 gap-0">
                <div className={`${index % 2 === 1 ? 'md:order-2' : ''}`}>
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top min-h-[400px]"
                  />
                </div>
                <div className="p-10 flex flex-col justify-center">
                  <div className="w-14 h-14 flex items-center justify-center bg-gray-100 mb-6">
                    <i className={`${service.icon} text-2xl text-primary`}></i>
                  </div>
                  <h4 className="text-2xl font-bold text-primary mb-4">
                    <strong>{service.title}</strong>
                  </h4>
                  <p className="text-secondary mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  <div className="grid grid-cols-2 gap-3">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <i className="ri-check-line text-primary text-lg"></i>
                        <span className="text-sm text-secondary">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
